// extracted by mini-css-extract-plugin
export var primitiveLabel = "_tg-0";